// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"771":"0d86f80b","888":"26501373"}[chunkId] + ".chunk.css";
};